import React from 'react';
import { PropTypes as PT } from 'prop-types';
import SVG from 'react-inlinesvg';
import alertIcon from '@lifesize/ux-assets/vectors/svgIcons/alert.svg';
import cancelIcon from '@lifesize/ux-assets/vectors/svgIcons/cancel.svg';
import classes from './NotificationMessage.module.scss';

/**
 * Notification Message component
 */
class NotificationMessage extends React.PureComponent {
  onRemove = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.removeNotification(this.props.id);
  };

  render() {
    return (
      <div className={`${classes.container} ${classes[this.props.color]}`}>
        <button
          className={classes.closeButton}
          data-testid="btn-close"
          onClick={this.onRemove}
        >
          <SVG src={cancelIcon} data-testid="cancelIcon" />
        </button>
        <div className={classes.content}>
          <div className={classes.notificationIcon}>
            <SVG src={alertIcon} data-testid="alertIcon" />
          </div>
          <div className={classes.message}>
            {this.props.message}
          </div>
        </div>
      </div>
    );
  }
}

NotificationMessage.propTypes = {
  color: PT.string,
  id: PT.number.isRequired,
  message: PT.string.isRequired,
  removeNotification: PT.func.isRequired
};

NotificationMessage.defaultProps = {
  color: 'green'
};

export default NotificationMessage;
